import { Component, OnInit } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';

import { PermissionsStorageService } from './shared/services/permissions-storage.service';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  constructor(
    private permissionsStorageService: PermissionsStorageService,
    private permissionsService: NgxPermissionsService,
  ) {}

  ngOnInit() {
    const { permissions } = this.permissionsStorageService;
    if (permissions.length > 0) {
      this.permissionsService.loadPermissions(permissions);
    }
  }
}
